import {useQuery} from 'react-query'
import {EmbeddingFormModal} from './UserEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getUserById} from '../core/_requests'
import { EmbeddingsDeleteFile } from './UploadEmbeddings'
import { useCompanies } from '../../../../auth/core/Companies'

const UserEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {defaultCompany} = useCompanies()
  const {
    isLoading,
    data: detailData,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-embedding-${itemIdForUpdate}`,
    () => {
      return getUserById(defaultCompany?.company_id ?? '',itemIdForUpdate ?? '');
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <EmbeddingFormModal isUserLoading={isLoading} embedding={{_id: undefined}} />
  }

  else if(!isLoading && !error && detailData){
    return <EmbeddingsDeleteFile isUserLoading={isLoading} id={itemIdForUpdate} data={
      detailData
    }/>
  }

  return null
}

export {UserEditModalFormWrapper}
